import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#141413] px-6 text-[#F4F4F0]" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg border border-[#2E2E2A] bg-[#1E1E1C] p-12 text-center">
        <XCircle size={56} weight="duotone" className="mx-auto text-[#A3A39C]" />
        <h1 data-testid="payment-cancel-heading" className="mt-6 font-heading text-4xl font-light">Checkout cancelled.</h1>
        <p className="mt-4 text-sm leading-relaxed text-[#A3A39C]">
          No charge was made. Whenever you're ready, the packages will be waiting.
        </p>
        <Link
          to="/#packages"
          data-testid="back-to-packages-button"
          className="mt-8 inline-block border border-[#C49A6C] px-8 py-4 text-xs uppercase tracking-[0.15em] text-[#C49A6C] transition-colors duration-200 hover:bg-[#C49A6C] hover:text-[#141413]"
        >
          Back to Packages
        </Link>
      </div>
    </div>
  );
}
